import React, { useContext, useEffect, useState } from "react";
import LoaderSmall from "../Shared/LoderSmall/LoaderSmall";
import { Link } from "react-router-dom";
import { AuthContextTwo } from "../../contexts/AuthProviderTwo";
import toast from "react-hot-toast";

const PreferProfileTwo = () => {


  const { userTwo } = useContext(AuthContextTwo);
  const [loading, setLoading] = useState(false);

  const [profileData, setProfileData] = useState([]);
  const [Mainloading, setMainLoading] = useState(true);

  const fetchData = async () => {
    try {
      const response = await fetch(
        `https://tutor-tree-server-1.vercel.app/user/${userTwo?.email}`
      );
      const data = await response.json();
      setProfileData(data);
      setMainLoading(false);
    } catch (error) {
      console.error("Error fetching users:", error);
      setMainLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  ///////////////////////// AREA AND CITY /////////////////////////
  ////////////////////////////////////////////////////////////////
  const [districts, setDistricts] = useState([]);

  const fetchDistricts = async () => {
    try {
      const response = await fetch("https://tutor-tree-server-1.vercel.app/allDistrict");
      const data = await response.json();
      setDistricts(data);
    } catch (error) {
      console.error("Error fetching Districts:", error);
    }
  };

  useEffect(() => {
    fetchDistricts();
  }, []);

  ////////////////////////////////// khulna and chittagong area start ///////////////////////////////
  const [KhulnaArea, setKhulnaArea] = useState([]);
  const fetchKhulnaArea = async () => {
    try {
      const response = await fetch("https://tutor-tree-server-1.vercel.app/khulnaArea");
      const data = await response.json();
      setKhulnaArea(data);
    } catch (error) {
      console.error("Error fetching Districts:", error);
    }
  };

  useEffect(() => {
    fetchKhulnaArea();
  }, []);
  const [ChittagongArea, setChittagongArea] = useState([]);
  const fetchChittagongArea = async () => {
    try {
      const response = await fetch("https://tutor-tree-server-1.vercel.app/ChittagongArea");
      const data = await response.json();
      setChittagongArea(data);
    } catch (error) {
      console.error("Error fetching Districts:", error);
    }
  };

  useEffect(() => {
    fetchChittagongArea();
  }, []);

  const [DhakaArea, setDhakaArea] = useState([]);
  const fetchDhakaArea = async () => {
    try {
      const response = await fetch("https://tutor-tree-server-1.vercel.app/DhakaArea");
      const data = await response.json();
      setDhakaArea(data);
    } catch (error) {
      console.error("Error fetching Districts:", error);
    }
  };

  useEffect(() => {
    fetchDhakaArea();
  }, []);

  
  // const subjects = ["Math", "English", "Bangla", "Science", "History", "Geography", "Physics", "Chemistry", "Biology"];

  const subjects = [
    "Bangla", "English", "Biology", "Physics", "Chemistry", 
    "Higher Math", "ICT", "Business Studies", "Business Administration", 
    "Accounting", "Finance", "Home Economics", "Management", 
    "Marketing", "Finance and Banking", "Economics", "Civics", 
    "Geography", "Psychology", "Religious Studies", "Statistics", 
    "Sociology", "Commercial Geography", "Production Management and Marketing", 
    "Agricultural Education", "Logic", "Social Work", 
    "Islamic History and Culture", "History", "Political Science", 
    "Engineering Drawing", "Maths", "General Science", 
    "Business Entrepreneurship", "Electrical and Electronic Engineering", 
    "Physical Education, Health & Sports", "Bangladesh & Global Studies", 
    "Social Science", "Drawing", "Arts and craft"
]


const updateDataOnServer = async () => {
    setLoading(true);

    // Gather data from the state
    const experience = document.getElementById("experience").value;
    const postData = {
        experience,
        preCategories1: checkedItems[0] || "",
        preCategories2: checkedItems[1] || "",
        preCategories3: checkedItems[2] || "",
        preCategories4: checkedItems[3] || "",
        preCategories5: checkedItems[4] || "",
        preClasses1: checkedItemsTwo[0] || "",
        preClasses2: checkedItemsTwo[1] || "",
        preClasses3: checkedItemsTwo[2] || "",
        preClasses4: checkedItemsTwo[3] || "",
        preClasses5: checkedItemsTwo[4] || "",
        preLocation1: checkedItemsThree[0] || "",
        preLocation2: checkedItemsThree[1] || "",
        preLocation3: checkedItemsThree[2] || "",
        preLocation4: checkedItemsThree[3] || "",
        preLocation5: checkedItemsThree[4] || "",
        preArea1: checkedItemsFour[0] || "",
        preArea2: checkedItemsFour[1] || "",
        preArea3: checkedItemsFour[2] || "",
        preArea4: checkedItemsFour[3] || "",
        preArea5: checkedItemsFour[4] || "",
        preSubject1: checkedItemsFive[0] || "",
        preSubject2: checkedItemsFive[1] || "",
        preSubject3: checkedItemsFive[2] || "",
        preSubject4: checkedItemsFive[3] || "",
        preSubject5: checkedItemsFive[4] || "",
        email: userTwo.email,
    };
    console.log("postData", postData);
    const updateUrl = 'https://tutor-tree-server-1.vercel.app/user/updateImageThree';
    try {
        const updateResponse = await fetch(updateUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(postData),
        });

        const updateData = await updateResponse.json();
        console.log('Data updated on the server:', updateData);
        toast.success('Data updated successfully');
    } catch (error) {
        console.error('Error updating data on the server:', error);
    } finally {
        setLoading(false);
    }
};



  const [checkedItems, setCheckedItems] = useState([]);

  const handleChange = (event) => {
    const label = event.target.nextSibling.htmlFor;

    if (event.target.checked) {
      if (checkedItems.length >= 5) {
        // Show toast message and prevent adding the item
        toast.warn("You can only select up to 5 items.");
        event.target.checked = false; // Optionally, uncheck the checkbox
      } else {
        // Add the label to the state if checked
        setCheckedItems((prevItems) => [...prevItems, label]);
      }
    } else {
      // Remove the label from the state if unchecked
      setCheckedItems((prevItems) =>
        prevItems.filter((item) => item !== label)
      );
    }
  };

  const [checkedItemsTwo, setCheckedItemsTwo] = useState([]);

  const handleChangeTwo = (event) => {
    const label = event.target.nextSibling.htmlFor;
    if (event.target.checked) {
      // Add the label to the state if checked
      setCheckedItemsTwo((prevItems) => [...prevItems, label]);
    } else {
      // Remove the label from the state if unchecked
      setCheckedItemsTwo((prevItems) =>
        prevItems.filter((item) => item !== label)
      );
    }
  };

  const [checkedItemsThree, setCheckedItemsThree] = useState([]);

  const handleChangeThree = (event) => {
    const label = event.target.nextSibling.htmlFor;
    if (event.target.checked) {
      // Add the label to the state if checked
      setCheckedItemsThree((prevItems) => [...prevItems, label]);
    } else {
      // Remove the label from the state if unchecked
      setCheckedItemsThree((prevItems) =>
        prevItems.filter((item) => item !== label)
      );
    }
  };

  const [checkedItemsFour, setCheckedItemsFour] = useState([]);

  const handleChangeFour = (event) => {
    const label = event.target.nextSibling.htmlFor;
    if (event.target.checked) {
      // Add the label to the state if checked
      setCheckedItemsFour((prevItems) => [...prevItems, label]);
    } else {
      // Remove the label from the state if unchecked
      setCheckedItemsFour((prevItems) =>
        prevItems.filter((item) => item !== label)
      );
    }
  };

  const [checkedItemsFive, setCheckedItemsFive] = useState([]);

  const handleChangeFive = (event) => {
    const label = event.target.nextSibling.htmlFor;
    if (event.target.checked) {
      // Add the label to the state if checked
      setCheckedItemsFive((prevItems) => [...prevItems, label]);
    } else {
      // Remove the label from the state if unchecked
      setCheckedItemsFive((prevItems) =>
        prevItems.filter((item) => item !== label)
      );
    }
  };

  const handleRemove = (itemToRemove) => {
    setCheckedItems((prevItems) =>
      prevItems.filter((item) => item !== itemToRemove)
    );
    // Uncheck the checkbox
    const checkbox = document.getElementById(itemToRemove);
    if (checkbox) {
      checkbox.checked = false;
    }
  };

  const formattedOutput = checkedItems.map((item) => (
    <div
      className="flex flex-row justify-between pl-2 items-center m-2 bg-orange-100 h-7  rounded-3xl"
      key={item}
    >
      {item}
      <button
        onClick={() => handleRemove(item)}
        className="w-7 h-7 ml-1 bg-orange-500 hover:bg-orange-600 text-white flex justify-center items-center rounded-full"
      >
        X
      </button>
    </div>
  ));
  /////////////////// remove two ///////
  const handleRemoveTwo = (itemToRemove) => {
    setCheckedItemsTwo((prevItems) =>
      prevItems.filter((item) => item !== itemToRemove)
    );
    // Uncheck the checkbox
    const checkbox = document.getElementById(itemToRemove);
    if (checkbox) {
      checkbox.checked = false;
    }
  };

  const formattedOutputTwo = checkedItemsTwo.map((item) => (
    <div
      className="flex flex-row justify-between pl-2 items-center m-2 bg-orange-100 h-7  rounded-3xl"
      key={item}
    >
      {item}
      <button
        onClick={() => handleRemoveTwo(item)}
        className="w-7 h-7 ml-1 bg-orange-500 hover:bg-orange-600 text-white flex justify-center items-center rounded-full"
      >
        X
      </button>
    </div>
  ));

  ////////////////// remove three ///////////
  const handleRemoveThree = (itemToRemove) => {
    setCheckedItemsThree((prevItems) =>
      prevItems.filter((item) => item !== itemToRemove)
    );
    // Uncheck the checkbox
    const checkbox = document.getElementById(itemToRemove);
    if (checkbox) {
      checkbox.checked = false;
    }
  };

  const formattedOutputThree = checkedItemsThree.map((item) => (
    <div
      className="flex flex-row justify-between pl-2 items-center m-2 bg-orange-100 h-7  rounded-3xl"
      key={item}
    >
      {item}
      <button
        onClick={() => handleRemoveThree(item)}
        className="w-7 h-7 ml-1 bg-orange-500 hover:bg-orange-600 text-white flex justify-center items-center rounded-full"
      >
        X
      </button>
    </div>
  ));

  ////////////////// remove Four ///////////
  const handleRemoveFour = (itemToRemove) => {
    setCheckedItemsFour((prevItems) =>
      prevItems.filter((item) => item !== itemToRemove)
    );
    // Uncheck the checkbox
    const checkbox = document.getElementById(itemToRemove);
    if (checkbox) {
      checkbox.checked = false;
    }
  };

  const formattedOutputFour = checkedItemsFour.map((item) => (
    <div
      className="flex flex-row justify-between py-1 pl-2 items-center m-2 bg-orange-100   rounded-3xl"
      key={item}
    >
      {item}
      <button
        onClick={() => handleRemoveFour(item)}
        className="w-7 h-7 ml-1 bg-orange-500 hover:bg-orange-600 text-white flex justify-center items-center rounded-full"
      >
        X
      </button>
    </div>
  ));

  const handleRemoveFive = (itemToRemove) => {
    setCheckedItemsFive((prevItems) =>
      prevItems.filter((item) => item !== itemToRemove)
    );
    // Uncheck the checkbox
    const checkbox = document.getElementById(itemToRemove);
    if (checkbox) {
      checkbox.checked = false;
    }
  };

  const formattedOutputFive = checkedItemsFive.map((item) => (
    <div
      className="flex flex-row justify-between pl-2 items-center m-2 bg-orange-100 h-7  rounded-3xl"
      key={item}
    >
      {item}
      <button
        onClick={() => handleRemoveFive(item)}
        className="w-7 h-7 ml-1 bg-orange-500 hover:bg-orange-600 text-white flex justify-center items-center rounded-full"
      >
        X
      </button>
    </div>
  ));
  
  const classMapping = {
    "Pre-Schooling": "Pre-Schooling",
    Play: "Play",
    Nursery: "Nursery",
    KG: "KG",
    BM1: "Class 1",
    BM2: "Class 2",
    BM3: "Class 3",
    BM4: "Class 4",
    BM5: "Class 5",
    BM6: "Class 6",
    BM7: "Class 7",
    BM8: "Class 8",
    BM9: "Class 9",
    BM10: "Class 10",
    "BMHSC-1stYear": "HSC-1st Year",
    "BMHSC-2stYear": "HSC-2nd Year",
    EV1: "Class 1",
    EV2: "Class 2",
    EV3: "Class 3",
    EV4: "Class 4",
    EV5: "Class 5",
    EV6: "Class 6",
    EV7: "Class 7",
    EV8: "Class 8",
    EV9: "Class 9",
    EV10: "Class 10",
    "EVHSC-1stYear": "HSC-1st Year",
    "EVHSC-2stYear": "HSC-2nd Year",
    EM1: "Class 1",
    EM2: "Class 2",
    EM3: "Class 3",
    EM4: "Class 4",
    EM5: "Class 5",
    EM6: "Class 6",
    EM7: "Class 7",
    EM8: "Class 8",
    EM9: "Class 9",
    OLevel: "OLevel",
    ALevelAS: "A Level (AS)",
    ALevelA2: "A Level (A2)",
    "EMHSC-2stYear": "HSC-2nd Year",
    Alim1: "Class 1",
    Alim2: "Class 2",
    Alim3: "Class 3",
    Alim4: "Class 4",
    Alim5: "Class 5",
    Alim6: "Class 6",
    Alim7: "Class 7",
    Alim8: "Class 8",
    Alim9: "Class 9",
    Alim10: "Class 10",
    "Alim-1stYear": "Alim-1st Year",
    "Alim-2stYear": "Alim-2nd Year",
    IslamicStudies: "Islamic Studies",
    HinduismStudies: "Hinduism Studies",
    BuddhismStudies: "Buddhism Studies",
    ChristianityStudies: "Christianity Studies",
    SchoolAdmissionTest: "School Admission Test",
    PublicUniversityAdmissionTest: "Public University Admission Test",
    PrivateUniversityAdmissionTest: "Private University Admission Test",
    MedicalCollegeAdmissionTest: "Medical College Admission Test",
    EngineeringUniversityAdmissionTest: "Engineering University Admission Test",
    Arts: "Arts",
    Music: "Music",
    InstrumentalMusic: "Instrumental Music",
    Dance: "Dance",
    Crafting: "Crafting",
    Recitation: "Recitation",
    TestPreparation: "Test Preparation",
    IELTS: "IELTS",
    TOEFL: "TOEFL",
    GRE: "GRE",
    GMAT: "GMAT",
    SAT: "SAT",
    GED: "GED",
  };

  
  return (
    <div>
       {
        profileData.map(profile =>
          <div>
          <div className="grid lg:grid-cols-2 sm:grid-cols-1 mt-5 gap-5 mx-5">
          <details className="dropdown w-full">
           <summary className="w-full selectTextMain cursor-pointer flex overflow-y-scroll justify-between px-4 items-center h-16 bg-white border-2 border-orange-300 hover:border-orange-300 rounded-lg hover:bg-white text-black">
             {checkedItems.length > 0 ? (
               formattedOutput
             ) : (
              <h1 className="selectTextMain">{profile.preCategories1 ? "": "Select Category"} {profile.preCategories1} {profile.preCategories1 ? "," : "" } {profile.preCategories2}{profile.preCategories3 ? "," : "" } {profile.preCategories3}{profile.preCategories4 ? "," : "" } {profile.preCategories4}{profile.preCategories5 ? "," : "" } {profile.preCategories5} </h1>
             )}
             <svg
               id="Layer_1"
               enable-background="new 0 0 128 128"
               height="20"
               viewBox="0 0 128 128"
               width="20"
               xmlns="http://www.w3.org/2000/svg"
             >
               <path
                 id="Down_Arrow_3_"
                 d="m64 88c-1.023 0-2.047-.391-2.828-1.172l-40-40c-1.563-1.563-1.563-4.094 0-5.656s4.094-1.563 5.656 0l37.172 37.172 37.172-37.172c1.563-1.563 4.094-1.563 5.656 0s1.563 4.094 0 5.656l-40 40c-.781.781-1.805 1.172-2.828 1.172z"
               />
             </svg>
           </summary>
           <ul className="p-2 shadow menu dropdown-content z-[1] bg-base-100 rounded-box w-full">
             <div className="form-checkbox">
               <div className="flex flex-row justify-start items-center">
                 <input
                   type="checkbox"
                   id="BanglaVersion"
                   className="checked:bg-blue-600 checked:border-transparent"
                   onChange={handleChange}
                 />
                 <label className="ml-4 selectTextMain" htmlFor="BanglaVersion">
                   Bangla Version
                 </label>
               </div>
               <div className="flex flex-row justify-start items-center">
                 <input
                   type="checkbox"
                   id="EnglishVersion"
                   className="checked:bg-blue-600 checked:border-transparent"
                   onChange={handleChange}
                 />
                 <label className="ml-4 selectTextMain" htmlFor="EnglishVersion">
                   English Version
                 </label>
               </div>
               <div className="flex flex-row justify-start items-center">
                 <input
                   type="checkbox"
                   id="EnglishMedium"
                   className="checked:bg-blue-600 checked:border-transparent"
                   onChange={handleChange}
                 />
                 <label className="ml-4 selectTextMain" htmlFor="EnglishMedium">
                   English Medium
                 </label>
               </div>
               <div className="flex flex-row justify-start items-center">
                 <input
                   type="checkbox"
                   id="MadrasaMedium"
                   className="checked:bg-blue-600 checked:border-transparent"
                   onChange={handleChange}
                 />
                 <label className="ml-4 selectTextMain" htmlFor="MadrasaMedium">
                   Madrasa Medium
                 </label>
               </div>
               <div className="flex flex-row justify-start items-center">
                 <input
                   type="checkbox"
                   id="ReligiousStudies"
                   className="checked:bg-blue-600 checked:border-transparent"
                   onChange={handleChange}
                 />
                 <label className="ml-4 selectTextMain" htmlFor="ReligiousStudies">
                   Religious Studies
                 </label>
               </div>
               <div className="flex flex-row justify-start items-center">
                 <input
                   type="checkbox"
                   id="AdmissionTest"
                   className="checked:bg-blue-600 checked:border-transparent"
                   onChange={handleChange}
                 />
                 <label className="ml-4 selectTextMain" htmlFor="AdmissionTest">
                   Admission Test
                 </label>
               </div>
               <div className="flex flex-row justify-start items-center">
                 <input
                   type="checkbox"
                   id="Arts"
                   className="checked:bg-blue-600 checked:border-transparent"
                   onChange={handleChange}
                 />
                 <label className="ml-4 selectTextMain" htmlFor="Arts">
                   Arts
                 </label>
               </div>
               <div className="flex flex-row justify-start items-center">
                 <input
                   type="checkbox"
                   id="TestPreparation"
                   className="checked:bg-blue-600 checked:border-transparent"
                   onChange={handleChange}
                 />
                 <label className="ml-4 selectTextMain" htmlFor="TestPreparation">
                   Test Preparation
                 </label>
               </div>
             </div>
           </ul>
         </details>
         {/* <div>Checked Items: {JSON.stringify(checkedItems)}</div> */}
   
         <details className="dropdown w-full">
           <summary className="w-full selectTextMain cursor-pointer flex justify-between px-4 items-center h-16 overflow-y-scroll bg-white border-2 border-orange-300 hover:border-orange-300 rounded-lg hover:bg-white text-black">
           {checkedItemsTwo.length > 0 ? (
               formattedOutputTwo
             ) : (
              <h1 className="selectTextMain">{profile.preClasses1 ? "": "Select Class"} {classMapping[profile.preClasses1]} {profile.preClasses1 ? "," : "" } {classMapping[profile.preClasses2]} {profile.preClasses2 ? "," : "" } {classMapping[profile.preClasses3]} {profile.preClasses3 ? "," : "" } {classMapping[profile.preClasses4]} {profile.preClasses4 ? "," : "" } {classMapping[profile.preClasses5]}</h1>

             )}
             <svg
               id="Layer_1"
               enable-background="new 0 0 128 128"
               height="20"
               viewBox="0 0 128 128"
               width="20"
               xmlns="http://www.w3.org/2000/svg"
             >
               <path
                 id="Down_Arrow_3_"
                 d="m64 88c-1.023 0-2.047-.391-2.828-1.172l-40-40c-1.563-1.563-1.563-4.094 0-5.656s4.094-1.563 5.656 0l37.172 37.172 37.172-37.172c1.563-1.563 4.094-1.563 5.656 0s1.563 4.094 0 5.656l-40 40c-.781.781-1.805 1.172-2.828 1.172z"
               />
             </svg>
           </summary>
           <ul className="p-2 shadow menu h-56 overflow-y-scroll dropdown-content z-[1] bg-base-100 rounded-box w-full">
             {checkedItems.includes("BanglaVersion") && (
               <div className="form-checkbox">
                 <div className="flex flex-row justify-center items-center w-full bg-orange-100 rounded-lg">
                   <h1 className="selectTextMain text-center">Bangla Version</h1>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="Pre-Schooling"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="Pre-Schooling">
                     Pre-Schooling
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="Play"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="Play">
                     Play
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="Nursery"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="Nursery">
                     Nursery
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="KG"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="KG">
                     KG
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="BM1"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="BM1">
                     Class 1
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="BM2"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="BM2">
                     Class 2
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="BM3"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="BM3">
                     Class 3
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="BM4"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="BM4">
                     Class 4
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="BM5"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="BM5">
                     Class 5
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="BM6"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="BM6">
                     Class 6
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="BM7"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="BM7">
                     Class 7
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="BM8"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="BM8">
                     Class 8
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="BM9"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="BM9">
                     Class 9
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="BM10"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="BM10">
                     Class 10
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="BMHSC-1stYear"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="BMHSC-1stYear">
                     HSC-1st Year
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="BMHSC-2stYear"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="BMHSC-2stYear">
                     HSC-2nd Year
                   </label>
                 </div>
               </div>
             )}
             {checkedItems.includes("EnglishVersion") && (
               <div className="form-checkbox">
                 <div className="flex flex-row justify-center items-center w-full bg-orange-100 rounded-lg">
                   <h1 className="selectTextMain text-center">English Version</h1>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="Pre-Schooling"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="Pre-Schooling">
                     Pre-Schooling
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="Play"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="Play">
                     Play
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="Nursery"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="Nursery">
                     Nursery
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="KG"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="KG">
                     KG
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="EV1"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="EV1">
                     Class 1
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="EV2"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="EV2">
                     Class 2
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="EV3"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="EV3">
                     Class 3
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="EV4"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="EV4">
                     Class 4
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="EV5"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="EV5">
                     Class 5
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="EV6"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="EV6">
                     Class 6
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="EV7"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="EV7">
                     Class 7
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="EV8"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="EV8">
                     Class 8
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="EV9"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="EV9">
                     Class 9
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="EV10"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="EV10">
                     Class 10
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="EVHSC-1stYear"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="EVHSC-1stYear">
                     HSC-1st Year
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="BMHSC-2stYear"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="BMHSC-2stYear">
                     HSC-1st Year
                   </label>
                 </div>
               </div>
             )}
             {checkedItems.includes("EnglishMedium") && (
               <div className="form-checkbox">
                 <div className="flex flex-row justify-center items-center w-full bg-orange-100 rounded-lg">
                   <h1 className="selectTextMain text-center">English Medium</h1>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="Pre-Schooling"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="Pre-Schooling">
                     Pre-Schooling
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="Play"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="Play">
                     Play
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="Nursery"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="Nursery">
                     Nursery
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="KG"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="KG">
                     KG
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="EM1"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="EM1">
                     Class 1
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="EM2"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="EM2">
                     Class 2
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="EM3"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="EM3">
                     Class 3
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="EM4"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="EM4">
                     Class 4
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="EM5"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="EM5">
                     Class 5
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="EM6"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="EM6">
                     Class 6
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="EM7"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="EM7">
                     Class 7
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="EM8"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="EM8">
                     Class 8
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="EM9"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="EM9">
                     Class 9
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="OLevel"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="OLevel">
                     O Level
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="ALevelAS"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="ALevelAS">
                     A Level (AS)
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="ALevelA2"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="ALevelA2">
                     A Level (A2)
                   </label>
                 </div>
               </div>
             )}
             {checkedItems.includes("MadrasaMedium") && (
               <div className="form-checkbox">
                 <div className="flex flex-row justify-center items-center w-full bg-orange-100 rounded-lg">
                   <h1 className="selectTextMain text-center">Madrasa Medium</h1>
                 </div>
   
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="Play"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="Play">
                     Play
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="Nursery"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="Nursery">
                     Nursery
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="KG"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="KG">
                     KG
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="Alim1"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="Alim1">
                     Alim 1
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="Alim2"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="Alim2">
                     Alim 2
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="Alim3"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="Alim3">
                     Alim 3
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="Alim4"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="Alim4">
                     Alim 4
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="Alim5"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="Alim5">
                     Alim 5
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="Alim6"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="Alim6">
                     Alim 6
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="Alim7"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="Alim7">
                     Alim 7
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="Alim8"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="Alim8">
                     Alim 8
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="Alim9"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="Alim9">
                     Alim 9
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="Alim 10"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="Alim 10">
                     Alim 10
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="Alim-1stYear"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="Alim-1stYear">
                     Alim-1st Year
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="Alim-2nd Year"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="Alim-2nd Year">
                     Alim-2nd Year
                   </label>
                 </div>
               </div>
             )}
             {checkedItems.includes("ReligiousStudies") && (
               <div className="form-checkbox">
                 <div className="flex flex-row justify-center items-center w-full bg-orange-100 rounded-lg">
                   <h1 className="selectTextMain text-center">
                     Religious Studies
                   </h1>
                 </div>
   
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="IslamicStudies"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="IslamicStudies">
                     Islamic Studies
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="HinduismStudies"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label
                     className="ml-4 selectTextMain"
                     htmlFor="HinduismStudies"
                   >
                     Hinduism Studies
                   </label>
                 </div>
   
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="BuddhismStudies"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label
                     className="ml-4 selectTextMain"
                     htmlFor="BuddhismStudies"
                   >
                     Buddhism Studies
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="ChristianityStudies"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label
                     className="ml-4 selectTextMain"
                     htmlFor="ChristianityStudies"
                   >
                     Christianity Studies
                   </label>
                 </div>
               </div>
             )}
             {checkedItems.includes("AdmissionTest") && (
               <div className="form-checkbox">
                 <div className="flex flex-row justify-center items-center w-full bg-orange-100 rounded-lg">
                   <h1 className="selectTextMain text-center">AdmissionTest</h1>
                 </div>
   
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="SchoolAdmissionTest"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label
                     className="ml-4 selectTextMain"
                     htmlFor="SchoolAdmissionTest"
                   >
                     School Admission Test
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="PublicUniversityAdmissionTest"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label
                     className="ml-4 selectTextMain"
                     htmlFor="PublicUniversityAdmissionTest"
                   >
                     Public University AdmissionTest
                   </label>
                 </div>
   
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="PrivateUniversityAdmissionTest"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label
                     className="ml-4 selectTextMain"
                     htmlFor="PrivateUniversityAdmissionTest"
                   >
                     Private University AdmissionTest
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="MedicalCollegeAdmissionTest"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label
                     className="ml-4 selectTextMain"
                     htmlFor="MedicalCollegeAdmissionTest"
                   >
                     Medical College AdmissionTest
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="EngineeringUniversityAdmissionTest"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label
                     className="ml-4 selectTextMain"
                     htmlFor="EngineeringUniversityAdmissionTest"
                   >
                     Engineering University AdmissionTest
                   </label>
                 </div>
               </div>
             )}
             {checkedItems.includes("Arts") && (
               <div className="form-checkbox">
                 <div className="flex flex-row justify-center items-center w-full bg-orange-100 rounded-lg">
                   <h1 className="selectTextMain text-center">Arts</h1>
                 </div>
   
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="Handwriting"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="Handwriting">
                     Handwriting
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="Music"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="Music">
                     Music
                   </label>
                 </div>
   
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="InstrumentalMusic"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label
                     className="ml-4 selectTextMain"
                     htmlFor="InstrumentalMusic"
                   >
                     InstrumentalMusic
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="Dance"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="Dance">
                     Dance
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="Crafting"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="Crafting">
                     Crafting
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="Recitation"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="Recitation">
                     Recitation
                   </label>
                 </div>
               </div>
             )}
             {checkedItems.includes("TestPreparation") && (
               <div className="form-checkbox">
                 <div className="flex flex-row justify-center items-center w-full bg-orange-100 rounded-lg">
                   <h1 className="selectTextMain text-center">Test Preparation</h1>
                 </div>
   
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="IELTS"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="IELTS">
                     IELTS
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="TOEFL"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="TOEFL">
                     TOEFL
                   </label>
                 </div>
   
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="GRE"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="GRE">
                     GRE
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="GMAT"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="GMAT">
                     GMAT
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="SAT"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="SAT">
                     SAT
                   </label>
                 </div>
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id="GED"
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeTwo}
                   />
                   <label className="ml-4 selectTextMain" htmlFor="GED">
                     GED
                   </label>
                 </div>
               </div>
             )}
           </ul>
         </details>
   
         {/* district area */}
         <details className="dropdown w-full">
           <summary className="w-full selectTextMain overflow-y-scroll h-16 cursor-pointer flex justify-between px-4 items-center bg-white border-2 border-orange-300 hover:border-orange-300 rounded-lg hover:bg-white text-black">
             {checkedItemsThree.length > 0 ? (
               formattedOutputThree
             ) : (
              <h1 className="selectTextMain">{profile.preLocation1 ? "": "Select Location"} {profile.preLocation1} {profile.preLocation1 ? "," : "" } {profile.preLocation2}{profile.preLocation3 ? "," : "" } {profile.preLocation3}{profile.preLocation4 ? "," : "" } {profile.preLocation4}{profile.preLocation5 ? "," : "" } {profile.preLocation5} </h1>

             )}
             <svg
               id="Layer_1"
               enable-background="new 0 0 128 128"
               height="20"
               viewBox="0 0 128 128"
               width="20"
               xmlns="http://www.w3.org/2000/svg"
             >
               <path
                 id="Down_Arrow_3_"
                 d="m64 88c-1.023 0-2.047-.391-2.828-1.172l-40-40c-1.563-1.563-1.563-4.094 0-5.656s4.094-1.563 5.656 0l37.172 37.172 37.172-37.172c1.563-1.563 4.094-1.563 5.656 0s1.563 4.094 0 5.656l-40 40c-.781.781-1.805 1.172-2.828 1.172z"
               />
             </svg>
           </summary>
           <ul className="p-2 shadow menu dropdown-content z-[1] bg-base-100 rounded-box w-full">
             {districts.map((dis) => (
               <div className="form-checkbox">
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id={dis.district}
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeThree}
                   />
                   <label className="ml-4 selectTextMain" htmlFor={dis.district}>
                     {dis.district}
                   </label>
                 </div>
               </div>
             ))}
           </ul>
         </details>
         {/* <div>Checked Items: {JSON.stringify(checkedItemsThree)}</div> */}
   
         <details className="dropdown w-full">
           <summary className="w-full selectTextMain overflow-y-scroll  cursor-pointer  flex justify-between px-4 items-center h-16 bg-white border-2 border-orange-300 hover:border-orange-300 rounded-lg hover:bg-white text-black">
             {checkedItemsFour.length > 0 ? (
               formattedOutputFour
             ) : (
              <h1 className="selectTextMain">{profile.preArea1 ? "": "Select Area"} {profile.preArea1} {profile.preArea1 ? "," : "" } {profile.preArea2}{profile.preArea3 ? "," : "" } {profile.preArea3}{profile.preArea4 ? "," : "" } {profile.preArea4}{profile.preArea5 ? "," : "" } {profile.preArea5} </h1>

             )}
             <svg
               id="Layer_1"
               enable-background="new 0 0 128 128"
               height="20"
               viewBox="0 0 128 128"
               width="20"
               xmlns="http://www.w3.org/2000/svg"
             >
               <path
                 id="Down_Arrow_3_"
                 d="m64 88c-1.023 0-2.047-.391-2.828-1.172l-40-40c-1.563-1.563-1.563-4.094 0-5.656s4.094-1.563 5.656 0l37.172 37.172 37.172-37.172c1.563-1.563 4.094-1.563 5.656 0s1.563 4.094 0 5.656l-40 40c-.781.781-1.805 1.172-2.828 1.172z"
               />
             </svg>
           </summary>
           <ul className="p-2 shadow menu h-56 overflow-y-scroll dropdown-content z-[1] bg-base-100 rounded-box w-full">
             {checkedItemsThree.includes("Chittagong") && (
               <div className="form-checkbox">
                 {ChittagongArea.map((area) => (
                   <div className="form-checkbox">
                     <div className="flex flex-row justify-start items-center">
                       <input
                         type="checkbox"
                         id={area.district}
                         className="checked:bg-blue-600 checked:border-transparent"
                         onChange={handleChangeFour}
                       />
                       <label className="ml-4 selectTextMain" htmlFor={area.area}>
                         {area.area}
                       </label>
                     </div>
                   </div>
                 ))}
               </div>
             )}
             {checkedItemsThree.includes("Khulna") && (
               <div className="form-checkbox">
                 {KhulnaArea.map((area) => (
                   <div className="form-checkbox">
                     <div className="flex flex-row justify-start items-center">
                       <input
                         type="checkbox"
                         id={area.district}
                         className="checked:bg-blue-600 checked:border-transparent"
                         onChange={handleChangeFour}
                       />
                       <label className="ml-4 selectTextMain" htmlFor={area.area}>
                         {area.area}
                       </label>
                     </div>
                   </div>
                 ))}
               </div>
             )}
             {checkedItemsThree.includes("Dhaka") && (
               <div className="form-checkbox">
                 {DhakaArea.map((area) => (
                   <div className="form-checkbox">
                     <div className="flex flex-row justify-start items-center">
                       <input
                         type="checkbox"
                         id={area.district}
                         className="checked:bg-blue-600 checked:border-transparent"
                         onChange={handleChangeFour}
                       />
                       <label className="ml-4 selectTextMain" htmlFor={area.area}>
                         {area.area}
                       </label>
                     </div>
                   </div>
                 ))}
               </div>
             )}
           </ul>
         </details>
         <details className="dropdown w-full">
           <summary className="w-full selectTextMain cursor-pointer flex overflow-y-scroll justify-between px-4 items-center h-16 bg-white border-2 border-orange-300 hover:border-orange-300 rounded-lg hover:bg-white text-black">
             {checkedItemsFive.length > 0 ? (
               formattedOutputFive
             ) : (
              <h1 className="selectTextMain">{profile.preSubject1 ? "": "Select Subject"} {profile.preSubject1} {profile.preSubject1 ? "," : "" } {profile.preSubject2}{profile.preSubject3 ? "," : "" } {profile.preSubject3}{profile.preSubject4 ? "," : "" } {profile.preSubject4}{profile.preSubject5 ? "," : "" } {profile.preSubject5} </h1>
             )}
             <svg
               id="Layer_1"
               enable-background="new 0 0 128 128"
               height="20"
               viewBox="0 0 128 128"
               width="20"
               xmlns="http://www.w3.org/2000/svg"
             >
               <path
                 id="Down_Arrow_3_"
                 d="m64 88c-1.023 0-2.047-.391-2.828-1.172l-40-40c-1.563-1.563-1.563-4.094 0-5.656s4.094-1.563 5.656 0l37.172 37.172 37.172-37.172c1.563-1.563 4.094-1.563 5.656 0s1.563 4.094 0 5.656l-40 40c-.781.781-1.805 1.172-2.828 1.172z"
               />
             </svg>
           </summary>
           <ul className="p-2 shadow menu dropdown-content z-[1] bg-base-100 rounded-box w-full">
             {
               subjects.map(subject=>
                 <div className="form-checkbox">
                 <div className="flex flex-row justify-start items-center">
                   <input
                     type="checkbox"
                     id={subject}
                     className="checked:bg-blue-600 checked:border-transparent"
                     onChange={handleChangeFive}
                   />
                   <label className="ml-4 selectTextMain" htmlFor={subject}>
                   {subject}
                   </label>
                 </div>
               </div>  
               )
             }
           </ul>
         </details>
         </div>
          <div className='px-5 mt-10'>
                       <div>
                       <div className='translate-y-3 ml-5 bg-white w-36 flex justify-center items-center textMain'>Tuition Experience</div>
   
                           <textarea
                               id="experience"
                               rows="4"
                               className="block p-2.5 w-full  border-2 textOptions pt-5 h-56 bg-orange-50 rounded-lg  border-orange-500 focus:ring-orange-500 focus:border-orange-500 "
                               placeholder={profile.experience ? profile.experience: "Enter your experience here..."}

                           ></textarea>
                       </div>
   
          </div>
           <div className='flex mt-10 px-5'>
                       <div>
                           {loading ? (
                               <button className='lg:w-32 sm:w-20 h-10 flex justify-center items-center bg-orange-400 text-white rounded my-5'>
                                   <LoaderSmall />
                               </button>
                               // Show the loader when uploading
                           ) : (
                               <button onClick={updateDataOnServer} className='lg:w-32 sm:w-20 h-10 flex justify-center items-center bg-orange-400 text-white rounded my-5'>
                                   SUBMIT
                               </button>
                           )}
                       </div>
                       <div className='lg:ml-10 sm:ml-4'>
                           <Link to="/dashboardTwo/tutorProfile">
                               <button className='lg:w-32 sm:w-20 h-10 flex justify-center items-center bg-transparent border-2 border-gray-400 buttonMjr transition duration-300 ease-in-out rounded my-5 hover:bg-slate-700 hover:text-white hover:border-slate-700'>Cancel</button></Link>
                       </div>
                   </div>
       </div>  
        )
       }
    </div>
  );
};

export default PreferProfileTwo;
